import React from 'react'
import defaultStyles from './ToggleButtonGroup.module.scss'
import { InfoTooltip } from '../InfoTooltip/InfoTooltip'
// 사용법 :
// toggleFieldLabel : 선택 분야 제목 (ex 성별)
// toggleFieldVariable : 선택 분야를 저장할 변수 (ex gender) , gender안에 male 또는 female 값 저장
// toggleOption : [{label(남) : value(남자)}, {label(여) : value(여자)}]
// onChange : 다른쪽 버튼을 눌렀을때 실행할 함수

const ToggleButtonGroup = ({
	toggleFieldLabel,
	toggleFieldVariable,
	toggleOption,
	onChange,
	styleMode = defaultStyles,
	disabledOptions = [],
	isNoticeNeed = false,
	isNoticeNeedText = '',
	isNoticePostion = 'top',
}) => {
	const onClick = (toggleFieldVariable, selected_option) => {
		if (toggleFieldVariable !== selected_option) {
			onChange(selected_option)
		}
	}

	return (
		<div>
			<div className={styleMode.labelContainer}>
				<div className={styleMode.label}>{toggleFieldLabel}</div>
				{isNoticeNeed && (
					<InfoTooltip
						id={`toggle-tooltip-${toggleFieldLabel}`}
						content={isNoticeNeedText}
						placement={isNoticePostion}
					/>
				)}
			</div>
			<div className={styleMode.toggleContainer}>
				{toggleOption.map(({ label, value }, index) => {
					const isDisabled = disabledOptions.includes(value)
					return (
						<button
							key={`${value}-${index}`}
							type="button"
							className={`${styleMode.buttonToggle} ${
								toggleFieldVariable === value ? styleMode.active : ''
							} ${isDisabled ? styleMode.disabled : ''}`}
							onClick={() => !isDisabled && onClick(toggleFieldVariable, value)}
							disabled={isDisabled}>
							{label}
						</button>
					)
				})}
			</div>
		</div>
	)
}

export default ToggleButtonGroup
